import { TerminalClosureSalesSummary } from "@towersystems/roam-common/lib/generated-types";
import { FlatActionList } from "@towersystems/roam-common-native";
import { Text } from "@towersystems/roam-common-native";
import { moneyToFormattedString } from "../../../../utilities/money";

export interface ShiftTotalsSummaryProps {
  item: TerminalClosureSalesSummary;
}

export const ShiftTotalsSummary = ({ item }: ShiftTotalsSummaryProps) => {
  return (
    <FlatActionList
      items={[
        {
          key: "1",
          title: "Total cash payments",
          componentRight: () => (
            <Text variant="heading1">
              {moneyToFormattedString(item.totalPayments)}
            </Text>
          ),
        },
        {
          key: "2",
          title: "Total cash refunds",
          componentRight: () => (
            <Text variant="heading1">
              {moneyToFormattedString(item.totalRefunds)}
            </Text>
          ),
        },
        {
          key: "3",
          title: "Total taxes",
          componentRight: () => (
            <Text variant="heading1">
              {moneyToFormattedString(item.totalTaxes)}
            </Text>
          ),
        },
        {
          key: "13",
          title: "Total sales",
          componentRight: () => (
            <Text variant="heading1">
              {moneyToFormattedString(item.totalSales)}
            </Text>
          ),
        },
        {
          key: "23",
          title: "Total Invoiced",
          componentRight: () => (
            <Text variant="heading1">
              {moneyToFormattedString(item.totalInvoices)}
            </Text>
          ),
        },
        {
          key: "26",
          title: "Total Laybys",
          componentRight: () => (
            <Text variant="heading1">
              {moneyToFormattedString(item.totalLaybys)}
            </Text>
          ),
        },
      ]}
    />
  );
};
